import { NetworkAffiliatePreferenceApi } from '@api';
import { networkAffiliatePreferenceTypes as actionTypes, affiliateTypes } from './types';

export const createNetworkAffiliatePreference = (affiliateId, params) => (dispatch) => {
  dispatch({
    type: actionTypes.CREATE.LOADING,
  });

  NetworkAffiliatePreferenceApi.create(affiliateId, { networkAffiliatePreference: params })
    .then((response) => {
      dispatch({
        type: affiliateTypes.LIST.HYDRATE,
        payload: { data: { id: affiliateId, preference: response.data } },
        method: 'add',
      });

      dispatch({
        type: actionTypes.CREATE.SUCCESS,
        payload: response,
        message: 'notify:general.save.success',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.CREATE.FAILURE,
        payload: { data: error.data },
        message: `notify:general.save.error.${error.status}`,
      });
    });
};
